export const AssetsTypes = {
    OPEN_CLOSE_VIEWER : 'OPEN_CLOSE_VIEWER_WINDOW_ASSETS',
    UPDATE_ASSET: 'UPDATE_ASSET_ASSETS',
    UPDATE_CONTENT: 'UPDATE_CONTENT_ASSETS',
    SHOW_HIDE_CONTENT: 'SHOW_HIDE_CONTENT_ASSETS',
    RESET : 'RESET'
};